/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import Styles from './styles.module.sass'
import { Flex, useBreakpointValue } from '@chakra-ui/react'
import { useResponsive } from '@/hooks/useResponsive'
import { setPreviewUrl } from '@/utils/items'

const SamsLogoDisplay = ({ coverUrls = [] }) => {
  const visibleCount = 5
  const coversToShow = coverUrls.slice(0, visibleCount)
  const remainingCount = coverUrls.length > visibleCount
    ? coverUrls.length - visibleCount
    : 0
  const coverSize = useBreakpointValue({
    base: Styles.bigCover,
    md: Styles.smallCover
  })
  const indicatorSize = useBreakpointValue({
    base: Styles.big,
    md: Styles.regular
  })
  const displayBoxes = coversToShow.map((coverUrl, index) => (
    <div
      key={index}
      className={`${Styles.coverContainer} ${coverSize}`}
    >
      <img
        src={setPreviewUrl(coverUrl)}
        className="object-cover h-full"
      />
    </div>
  ))
  const { flexDirection } = useResponsive()

  return (
    <Flex
      flexDirection={flexDirection}
      className={Styles.samsContainer}
    >
      <Flex
        justifyContent={{ base: 'space-around' }}
        alignItems="center"
        flexWrap="wrap"
        gap="10px"
      >
         { displayBoxes }
      </Flex>
      { remainingCount > 0 && (
        <div className={`${Styles.moreIndicator} ${indicatorSize}`}>
          + { remainingCount } more
        </div>
      )}
    </Flex>
  )
}

export default SamsLogoDisplay
